const POS_TAGS = {
  0: 'UNK',
  24: 'NNG',
  25: 'NNP',
  23: 'NNB',
  26: 'NP',
  27: 'NR',
  22: 'NF',
  21: 'NA',
  28: 'NV',
  41: 'VV',
  38: 'VA',
  42: 'VX',
  40: 'VCP',
  39: 'VCN',
  18: 'MMA',
  19: 'MMD',
  20: 'MMN',
  16: 'MAG',
  17: 'MAJ',
  6: 'IC',
  13: 'JKS',
  9: 'JKC',
  10: 'JKG',
  11: 'JKO',
  8: 'JKB',
  14: 'JKV',
  12: 'JKQ',
  15: 'JX',
  7: 'JC',
  3: 'EP',
  2: 'EF',
  1: 'EC',
  5: 'ETN',
  4: 'ETM',
  43: 'XPN',
  46: 'XSN',
  47: 'XSV',
  45: 'XSA',
  44: 'XR',
  30: 'SF',
  35: 'SP',
  36: 'SS',
  29: 'SE',
  34: 'SO',
  37: 'SW',
  32: 'SL',
  31: 'SH',
  33: 'SN'
};
const K_TAGS = {
  UNK: '',
  NNG: '일반 명사',
  NNP: '고유 명사',
  NNB: '의존 명사',
  NR: '수사',
  NP: '대명사',
  NF: '명사 추정 범주',
  VV: '동사',
  VA: '형용사',
  VX: '보조 용언',
  VCP: '긍정 지정사',
  VCN: '부정 지정사',
  MMA: '성상 관형사',
  MMD: '지시 관형사',
  MMN: '수 관형사',
  MAG: '일반 부사',
  MAJ: '접속 부사',
  IC: '감탄사',
  JKS: '주격 조사',
  JKC: '보격 조사',
  JKG: '관형격 조사',
  JKO: '목적격 조사',
  JKB: '부사격 조사',
  JKV: '호격 조사',
  JKQ: '인용격 조사',
  JX: '보조사',
  JC: '접속 조사',
  EP: '선어말 어미',
  EF: '종결 어미',
  EC: '연결 어미',
  ETN: '명사형 전성 어미',
  ETM: '관형형 전성 어미',
  XPN: '체언 접두사',
  XSN: '명사 파생 접미사',
  XSV: '동사 파생 접미사',
  XSA: '형용사 파생 접미사',
  XR: '어근',
  SF: '마침표, 물음표, 느낌표',
  SP: '쉼표, 가운뎃점, 콜론, 빗금',
  SS: '따옴표, 괄호표, 줄표',
  SE: '줄임표',
  SO: '붙임표(물결, 숨김, 빠짐)',
  SW: '기타기호 (논리수학기호, 화폐기호)',
  NA: '분석불능범주',
  SL: '외국어',
  SH: '한자',
  SN: '숫자',
  NV: '용언추정범주'
};
export function getPOSTag(number) {
  return POS_TAGS[number] || number;
}

const STYLE = {
  EC: 'rgba(94, 239, 241, 0.35)',
  EF: 'rgba(52, 238, 241, 0.35)',
  EP: 'rgba(10, 243, 247, 0.35)',
  ETM: 'rgba(133, 186, 187, 0.35)',
  ETN: 'rgba(150, 241, 243, 0.35)',
  IC: 'rgba(182, 226, 38, 0.35)',
  JC: 'rgba(156, 240, 195, 0.35)',
  JKB: 'rgba(127, 236, 94, 0.35)',
  JKC: 'rgba(195, 218, 121, 0.35)',
  JKG: 'rgba(67, 241, 14, 0.35)',
  JKO: 'rgba(96, 231, 54, 0.35)',
  JKQ: 'rgba(62, 231, 141, 0.35)',
  JKS: 'rgba(188, 219, 86, 0.35)',
  JKV: 'rgba(71, 255, 158, 0.35)',
  JX: 'rgba(105, 240, 168, 0.35)',
  MAG: 'rgba(212, 184, 83, 0.35)',
  MAJ: 'rgba(194, 255, 0, 0.35)',
  MMA: 'rgba(228, 197, 84, 0.35)',
  MMD: 'rgba(228, 187, 84, 0.35)',
  MMN: 'rgba(228, 177, 84, 0.35)',
  NA: 'rgba(24, 23, 23, 0.35)',
  NF: 'rgba(24, 23, 23, 0.35)',
  NNB: 'rgba(243, 121, 121, 0.35)',
  NNG: 'rgba(248, 7, 7, 0.35)',
  NNP: 'rgba(241, 63, 63, 0.35)',
  NP: 'rgba(241, 110, 35, 0.35)',
  NR: 'rgba(247, 94, 5, 0.35)',
  NV: 'rgba(24, 23, 23, 0.35)',
  SE: 'rgba(34, 69, 243, 0.35)',
  SF: 'rgba(5, 46, 248, 0.35)',
  SH: 'rgba(235, 6, 155, 0.35)',
  SL: 'rgba(225, 153, 241, 0.35)',
  SN: 'rgba(206, 53, 150, 0.35)',
  SO: 'rgba(95, 120, 243, 0.35)',
  SP: 'rgba(95, 53, 150, 0.35)',
  SS: 'rgba(99, 97, 2, 0.35)',
  SW: 'rgba(218, 104, 243, 0.35)',
  VA: 'rgba(238, 153, 100, 0.35)',
  VCN: 'rgba(236, 194, 41, 0.35)',
  VCP: 'rgba(245, 193, 7, 0.35)',
  VV: 'rgba(240, 134, 69, 0.35)',
  VX: 'rgba(243, 176, 135, 0.35)',
  XPN: 'rgba(6, 168, 243, 0.35)',
  XR: 'rgba(172, 227, 250, 0.35)',
  XSA: 'rgba(42, 95, 117, 0.35)',
  XSN: 'rgba(30, 148, 202, 0.35)',
  XSV: 'rgba(42, 124, 161, 0.35)'
};

const TAG = {
  EC: STYLE.EC,
  EF: STYLE.EF,
  EP: STYLE.EP,
  ETM: STYLE.ETM,
  ETN: STYLE.ETN,
  IC: STYLE.IC,
  JC: STYLE.JC,
  JKB: STYLE.JKB,
  JKC: STYLE.JKC,
  JKG: STYLE.JKG,
  JKO: STYLE.JKO,
  JKQ: STYLE.JKQ,
  JKS: STYLE.JKS,
  JKV: STYLE.JKV,
  JX: STYLE.JX,
  MAG: STYLE.MAG,
  MAJ: STYLE.MAJ,
  MMA: STYLE.MMA,
  MMD: STYLE.MMD,
  MMN: STYLE.MMN,
  NA: STYLE.NA,
  NF: STYLE.NF,
  NNB: STYLE.NNB,
  NNG: STYLE.NNG,
  NNP: STYLE.NNP,
  NP: STYLE.NP,
  NR: STYLE.NR,
  NV: STYLE.NV,
  SE: STYLE.SE,
  SF: STYLE.SF,
  SH: STYLE.SH,
  SL: STYLE.SL,
  SN: STYLE.SN,
  SO: STYLE.SO,
  SP: STYLE.SP,
  SS: STYLE.SS,
  SW: STYLE.SW,
  VA: STYLE.VA,
  VCN: STYLE.VCN,
  VCP: STYLE.VCP,
  VV: STYLE.VV,
  VX: STYLE.VX,
  XPN: STYLE.XPN,
  XR: STYLE.XR,
  XSA: STYLE.XSA,
  XSN: STYLE.XSN,
  XSV: STYLE.XSV
};

export function getTagColor(tagName) {
  return TAG[tagName] || 'white';
}

export function getTagKorea(tagName) {
  return K_TAGS[tagName] || 'white';
}
